import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ResearchView from "@/views/ResearchView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/research", //默认显示
  },
  {
    path: "/homepage-guocheng",
    name: "home",
    component: HomeView,
  },
  {
    path: "/research",
    name: "research",
    component: ResearchView,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
